/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React, {forwardRef, memo, useCallback} from 'react';
import {useSelector} from 'react-redux';
import {translate} from '@ion/core/src/locale/locale';
import {getAssetStatusOptions} from '@ion/dls/src/filters/AssetStatusFilter';
import {setAssetStatusFilters} from '@/store/actions/tracking';
import {trackingFiltersSelector} from '@/store/selectors/tracking-selectors';
import TrackingDrawerFilter, {
  TrackingDrawerFilterHandle,
  TrackingDrawerFilterOption
} from './TrackingDrawerFilter';
import {TrackingFilterStateKey} from './types';

export type TrackingAssetStatusFilterHandle = TrackingDrawerFilterHandle;

export interface TrackingAssetStatusFilterProps {
  onSelectedCountChange?: (count: number) => void;
  onSelectionChange?: () => void;
}

export const TrackingAssetStatusFilter = forwardRef<TrackingAssetStatusFilterHandle, TrackingAssetStatusFilterProps>(({
  onSelectedCountChange,
  onSelectionChange
}, ref) => {
  const trackingFilters     = useSelector(trackingFiltersSelector);
  const selectedAssetStatus = trackingFilters?.assetStatus?.selected ?? [];

  const loadOptions = useCallback(async(): Promise<TrackingDrawerFilterOption[]> => {
    return getAssetStatusOptions();
  }, []);

  return (
    <TrackingDrawerFilter ref={ref}
      applyFilter={setAssetStatusFilters}
      filterStateKey={TrackingFilterStateKey.AssetStatus}
      loadOptions={loadOptions}
      selectedItems={selectedAssetStatus}
      searchPlaceholder={translate('filters:tracking.assetStatus.searchPlaceholder')}
      onSelectedCountChange={onSelectedCountChange}
      onSelectionChange={onSelectionChange} />
  );
});

export default memo(TrackingAssetStatusFilter);
